import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTemplateTrialItemState: Dtos.TemplateTrialItem & IRegistrationFormState = {
    id: null,
    name: null,
    description: null,
    rank: null,
    categoryId: null,
    category: null,
    allowVersionChanges: null,
    allowIntraVersions: null,
    initialVersion: '1',
    pendingDelete: null,
    collectionId: null,
    collection: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    templateTrialItemGroups: []
}

export interface ITemplateTrialItemReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    rank: IFieldState<number>,
    categoryId: IFieldState<number>,
    allowVersionChanges: IFieldState<boolean>,
    allowIntraVersions: IFieldState<boolean>,
    pendingDelete: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    collectionId: IFieldState<number>,
    collection: IFieldState<Dtos.Collection>,
    templateTrialItemGroups: IFieldState<Dtos.TemplateTrialItemGroup[]>
}
